



/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../../constants";
import { fetchData } from "../../../../helpers";

// UPDATEREFERRALSSECTION
// UPDATEREFERRALSSECTION


const UPDATEREFERRALSSECTION= createAsyncThunk(
  "updateReferralSection/updateReferralSection",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const updateReferralSectionSlice = createSlice({
  name: "updateReferralSectionSlice",
  initialState: {
    updateReferralSection: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfupdateReferralSection: (state) => {
        state.updateReferralSection.loading = false
        state.updateReferralSection.error = false
        state.updateReferralSection.data = []
        state.updateReferralSection.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(UPDATEREFERRALSSECTION.fulfilled, (state, action) => {
      state.updateReferralSection = {
        ...state.updateReferralSection,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(UPDATEREFERRALSSECTION.pending, (state, action) => {
      state.updateReferralSection = {
        ...state.updateReferralSection,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(UPDATEREFERRALSSECTION.rejected, (state, action) => {
      state.updateReferralSection = {
        ...state.updateReferralSection,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const updateReferralSectionAction = {
    UPDATEREFERRALSSECTION,
};

export { updateReferralSectionAction };
export default updateReferralSectionSlice.reducer;
export const {setInitialStateOfupdateReferralSection} = updateReferralSectionSlice.actions
